/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/permissions.type';

export const getPermissionByApplication = (data: any) => ({
  type: actions.GET_APPLICATION_PERMISSIONS,
  payload: data,
});

export const getPermissionByApplicationSuccess = (data: any) => ({
  type: actions.GET_APPLICATION_PERMISSIONS_SUCCESS,
  payload: data,
});

export const getPermissionByApplicationFailure = (error: any) => ({
  type: actions.GET_APPLICATION_PERMISSIONS_FAILURE,
  payload: error,
});

export const updateCurrentPermission = (data: any) => ({
  type: actions.UPDATE_CURRENT_PERMISSION,
  payload: data,
});
